import {
  Box,
  Grid,
  Typography,
  Stack,
  Link,
  IconButton,
  Divider,
} from "@mui/material";

import TelegramIcon from "@mui/icons-material/Telegram";
import SvgIcon from "@mui/material/SvgIcon";
import AddIcon from "@mui/icons-material/Add";

const VkIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M3 5h4c.2 0 .4.1.5.3.7 1.6 1.4 3.2 2.4 4.6.4.6.7.7 1 .7.4 0 .5-.4.5-1.1V5h3.6c.3 0 .6.2.6.6 0 .9-.1 3 .1 3.5.1.4.3.5.6.5.3 0 .6-.2 1-.7 1-1.4 1.8-3.1 2.5-4.7.1-.2.3-.3.5-.3h3.8c.4 0 .6.2.5.6-.2 1-1.4 3.3-2.9 5.3-.5.7-.7 1.1 0 1.8 1 1 3 2.8 3.4 3.8.1.3-.1.6-.4.6h-4.2c-.3 0-.6-.1-.8-.3-.7-.7-1.6-2-2.3-2.7-.4-.4-.6-.5-.9-.5-.3 0-.4.3-.4.8v2.4c0 .3-.2.5-.5.5h-2.8c-4.5 0-7.8-3.1-9.5-8.2-.3-.9-.5-1.8-.6-2.7 0-.3.2-.6.5-.6z" />
  </SvgIcon>
);

const ZenIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm0 4c-2.2 0-4 1.8-4 4 0 1.6 1 3 2.4 3.6L8 18h8l-2.4-4.4C15 13 16 11.6 16 10c0-2.2-1.8-4-4-4z" />
  </SvgIcon>
);

const MaxIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M4 4h6l2 4 2-4h6l-5 8 5 8h-6l-2-4-2 4H4l5-8-5-8z" />
  </SvgIcon>
);



export default function LandingFooter() {
  return (
    <Box sx={{ bgcolor: "background.paper" }}>
      {/* Разделитель */}
      <Box sx={{ my: 6, position: "relative" }}>
        <Divider sx={{ borderStyle: "dashed", borderColor: "grey.300" }} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "7%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#f5f5f5",
            px: 1,
            py: 0.5,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AddIcon sx={{ color: "grey.500", fontSize: 20 }} />
        </Box>
      </Box>

      {/* Внутренний контейнер */}
      <Box
        sx={{
          maxWidth: 1400,
          mx: "auto",
          px: { xs: 2, md: 3 },
          width: "100%",
        }}
      >
        <Grid container spacing={6} alignItems="flex-start">
          {/* LEFT */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Stack spacing={3}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h5" fontWeight={700} sx={{ lineHeight: 1 }}>
                  <Box
                    component="span"
                    sx={{
                      background: `linear-gradient(
                        270deg,
                        #ffffff,
                        rgb(23, 135, 240),
                        rgb(245, 81, 16),
                        #ffffff
                      )`,
                      backgroundSize: "400% 400%",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      animation: "gradientAnimation 6s ease infinite",
                      "@keyframes gradientAnimation": {
                        "0%": { backgroundPosition: "0% 50%" },
                        "50%": { backgroundPosition: "100% 50%" },
                        "100%": { backgroundPosition: "0% 50%" },
                      },
                    }}
                  >
                    Спорт
                  </Box>
                  Подсчет
                </Typography>
              </Stack>

              <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380 }}>
                Сервис для хронометража, табло и управления хоккейным матчем. Современный интерфейс, надёжная синхронизация и
                профессиональный подход.
              </Typography>

              <Stack direction="row" spacing={1}>
                <IconButton
                  size="small"
                  aria-label="Telegram"
                  component="a"
                  href="https://t.me/sportpodschet"
                  target="_blank"
                  rel="noopener"
                >
                  <TelegramIcon fontSize="small" />
                </IconButton>

                <IconButton
                  size="small"
                  aria-label="VK"
                  component="a"
                  href="https://vk.com/sportpodschet"
                  target="_blank"
                  rel="noopener"
                >
                  <VkIcon fontSize="small" />
                </IconButton>

                <IconButton
                  size="small"
                  aria-label="Дзен"
                  component="a"
                  href="https://dzen.ru/sportpodschet"
                  target="_blank"
                  rel="noopener"
                >
                  <ZenIcon fontSize="small" />
                </IconButton>

                <IconButton size="small" aria-label="MAX" component="a" href="#">
                  <MaxIcon fontSize="small" />
                </IconButton>
              </Stack>
            </Stack>
          </Grid>

          {/* RIGHT */}
          <Grid size={{ xs: 12, md: 7 }}>
            <Grid
              container
              spacing={4}
              sx={{
                width: "100%",
                textAlign: { xs: "left", sm: "center", md: "left" },
              }}
            >
              {/* ✅ равномерно по 3 колонки */}
              <Grid size={{ xs: 12, sm: 4 }}>
                <Stack spacing={1.5}>
                  <Typography variant="subtitle2" fontWeight={700}>
                    Меню
                  </Typography>
                  <Link href="/" color="text.secondary" underline="none" variant="body2">
                    Главная
                  </Link>
                  <Link href="/features" color="text.secondary" underline="none" variant="body2">
                    Возможности
                  </Link>
                  <Link href="/demo" color="text.secondary" underline="none" variant="body2">
                    Демо
                  </Link>
                  <Link href="/pricing" color="text.secondary" underline="none" variant="body2">
                    Тарифы
                  </Link>
                </Stack>
              </Grid>

              <Grid size={{ xs: 12, sm: 4 }}>
                <Stack spacing={1.5}>
                  <Typography variant="subtitle2" fontWeight={700}>
                    Правовая информация
                  </Typography>
                  <Link href="/legal/terms" color="text.secondary" underline="none" variant="body2">
                    Пользовательское соглашение
                  </Link>
                  <Link href="/legal/privacy" color="text.secondary" underline="none" variant="body2">
                    Политика конфиденциальности
                  </Link>
                </Stack>
              </Grid>

              <Grid size={{ xs: 12, sm: 4 }}>
                <Stack spacing={1.5}>
                  <Typography variant="subtitle2" fontWeight={700}>
                    Контакты
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    89278596412
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    support@sportpodschet.ru
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Divider sx={{ my: 5 }} />

        <Typography variant="caption" color="text.secondary" align="center" display="block" sx={{ pb: 3 }}>
          © {new Date().getFullYear()} СпортПодсчет. Все права защищены.
        </Typography>
      </Box>
    </Box>
  );
}
